import { Typography, Stack, Paper, Card, Grid, Container } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate, useLocation, redirect } from "react-router-dom";

import React, { useEffect, useState } from "react";
import "./Login.scss";
import UE_SVG from "../../Images/Epic_logo.svg";
import login_svg from "../../Images/Epic_login.svg";
// import "bootstrap/dist/css/bootstrap.min.css";
import { ROLE, APP_ROUTES, API } from "../../globals/constants/index";
import { ToastContainer, toast } from "react-toastify";
import InputField from "../../components/common/InputField";
import Button from "../../components/common/Button";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { reduxLogin } from "../../redux/features/login";
import Cookies from "universal-cookie";
import { USER_LOGOUT, SET_ROLE } from "../../redux/features/login";
import uriBuilder from "../../globals/uri";
import appConfig from "../../globals/config";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import axios from "axios";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { Navigate } from "react-router-dom";

// import useMediaQuery from '@mui/material/useMediaQuery';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const response = useSelector((state) => state.login);

  useEffect(() => {
    console.log("Response", response);
  }, [response]);

  // New Vairables
  const [role, setRole] = useState({});
  const [email, setEmail] = useState({});
  const [password, setPassword] = useState({});
  const [emailError, setemailError] = useState("Please provide Email !");
  const [passError, setPassError] = useState("Please provide password !");
  const [showPass, setShowPass] = useState(false);
  const [load, setload] = useState(false);
  const location = useLocation();
  const cookies = new Cookies();

  const loginfun = async () => {
    setload(true);
    let params = {
      email_id: email,
      password: password,
      type: role.role,
    };
    // dispatch(reduxLogin(params));
    axios({
      method: "post",
      url: `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
        API.END_POINTS.LOGIN_ENDPOINT
      }`,
      data: params,
    })
      .then((response) => {
        setload(false);
        console.log("Inside Login Success");
        cookies.set("loginData", response?.data?.data, { path: "/" });
        if (
          response?.data?.data?.role_code === "SUPER_ADMIN" ||
          response?.data?.data?.role_code === "STUDIO_ADMIN"
        ) {
          // window.location.pathname = APP_ROUTES.ROUTE_ROOT;
          navigate(APP_ROUTES.ROUTE_ROOT);
        } else {
          navigate("/veyon");
          // window.location.href = '/veyon';
        }
        return response.data;
      })
      .catch((res) => {
        setload(false);
        console.log("Inside Login Error");
        if (res.response.status === 400) {
          toast.error(`Please check epic credentials`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else {
          toast.error(res?.response?.data?.msg1, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        }
      });

    let validate = await validateData();

    // if (validate) {
    //   if (role.role === ROLE.STUDIO_ADMIN) {
    //  params.body.type = "STUDIO_ADMIN";
    //  params.url = api.API_STUDIO_ADMIN_SIGNIN;
    //  dispatch({ type: CONSTATNT.USER_FETCH_REQUESTED, payload: params });
    //   } else if (role.role === ROLE.INSTRUCTOR) {
    //  params.body.type = "INSTRUCTOR";
    //  params.url = api.API_INSTRUCTOR_SIGNIN;
    //  dispatch({ type: CONSTATNT.USER_FETCH_REQUESTED, payload: params });
    //   } else if (role.role === ROLE.STUDENT) {
    //  params.body.type = "STUDENT";
    //  params.url = api.API_STUDIO_ADMIN_SIGNIN;
    //  dispatch({ type: CONSTATNT.USER_FETCH_REQUESTED, payload: params });
    //   } else if (location.pathname === APP_ROUTES.ADMIN_PATH) {
    //  params.body.type = "SUPER_ADMIN";
    //  params.url = api.API_ADMIN_SIGNIN;
    //  dispatch({ type: CONSTATNT.USER_FETCH_REQUESTED, payload: params });
    //   }
    // }
  };

  const validateData = () => {
    if (email !== "" && password !== "") {
      setemailError();
      setPassError();
      return true;
    } else if (email === "" && password === "") {
      setemailError("Please provide email !");
      setPassError("Please provide passowrd !");
      return false;
    } else if (email === "") {
      setPassError();
      setemailError("Please provide email !");
      return false;
    } else if (password === "") {
      setemailError();
      setPassError("Please provide passowrd !");
      return false;
    }
  };

  const redirect = () => {
    dispatch(SET_ROLE(role.role));
    const redirectLink = uriBuilder(appConfig.nhsRootDomain + "/authorize", [
      { key: "client_id", value: appConfig.clientId },
      { key: "scope", value: appConfig.scope },
      { key: "response_type", value: appConfig.responseType },
      { key: "redirect_uri", value: appConfig.redirectUri },
    ]);
    console.log(`redirectLink---->${redirectLink}`);
    console.log(`redirect_uri---->${appConfig.redirectUri}`);
    window.location.href = redirectLink;
  };

  const logout = () => {
    dispatch(USER_LOGOUT());
    cookies.remove("loginData", { path: "/" });
  };

  useEffect(() => {
    logout();
    if (window.location.pathname === "/admin/login") {
      setRole({ role: "SUPER_ADMIN", label: "SUPER ADMIN" });
    }
  }, []);

  return (
    <>
      {load ? (
        <MultiLine_Spinner />
      ) : (
        <Stack className="parentDiv">
          <div className="ueContainer">
            <img src={UE_SVG} />
          </div>

          <Stack
            className="login"
            spacing={1}
            display="flex"
            justifyContent="center"
          >
            <Stack className="login_container">
              <div className="loginImg">
                <img src={login_svg} />
              </div>
              <Stack>
                <Typography className="loginTypeName">
                  {role.role ? `${role.label}` : ""}
                </Typography>
              </Stack>
              <div className="formContainer">
                {/* Comment this while deploying */}
                {/* {role && (
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Stack className="input_field">
                        <InputField
                          placeholder="Email address"
                          onChange={(data) => {
                            setEmail(data.target.value);
                          }}
                        />
                      </Stack>
                      <p style={{ color: "red" }}>
                        {email === "" ? emailError : ""}
                      </p>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Stack className="input_field">
                        <InputField
                          type={!showPass ? "password" : "text"}
                          placeholder="Password"
                          onChange={(data) => setPassword(data.target.value)}
                        /> */}
                {/* <button onClick={(e)=>{
                            e.preventDefault()
                            setShowPass(!showPass)}
                            }>show password
                            </button> */}
                {/* </Stack>

                      <p style={{ color: "red" }}>
                        {password === "" ? passError : ""}
                      </p>
                    </Grid>
                  </Grid>
                )} */}
                {/* Upto here */}

                <Stack className="login_type_container marginTopMinus">
                  <Box
                  // onClick={() => {
                  //    redirect();
                  // }}
                  >
                    <Typography className="loginType">
                      <div className="btn_container">
                        <Button
                          // role="primary"
                          value={`Sign In With Epic Games`}
                          className="login_btn"
                          onClick={redirect}
                          disabled={
                            // window.location.pathname === "/admin/login"
                            //   ? ""
                            //   :
                            role.role
                              ? false
                              : location.pathname === APP_ROUTES.ADMIN_PATH
                              ? false
                              : true
                          }
                        />
                      </div>
                    </Typography>
                  </Box>
                </Stack>
              </div>
            </Stack>
            {location.pathname !== APP_ROUTES.ADMIN_PATH && (
              // <div className="container">
              <>
                {window.location.pathname === "/admin/login" ? (
                  /* Comment this while deploying stagging or prod*/
                  // <Stack
                  //   direction={{
                  //     xs: "column",
                  //     sm: "row",
                  //     md: "row",
                  //     lg: "row",
                  //   }}
                  //   className='login_type_container'
                  // >
                  //   <Box
                  //     onClick={() => {
                  //       // alert();
                  //       setRole({
                  //         // role: ROLE.STUDIO_ADMIN,
                  //         // label: ROLE.STUDIO_ADMIN,
                  //         role: ROLE.ADMIN,
                  //         label: "SUPER ADMIN",
                  //       });
                  //     }}
                  //   >
                  //     <Typography className='loginType'>Super Admin</Typography>
                  //   </Box>
                  // </Stack>
                  <></>
                ) : (
                  <Stack
                    direction={{
                      xs: "column",
                      sm: "row",
                      md: "row",
                      lg: "row",
                    }}
                    className="login_type_container"
                  >
                    <Typography
                      className="loginType"
                      onClick={() =>
                        setRole({
                          role: ROLE.STUDIO_ADMIN,
                          label: "TRAINING CENTER ADMIN",
                        })
                      }
                    >
                      Training Center Login
                    </Typography>
                    <Typography
                      className="loginType"
                      onClick={() =>
                        setRole({
                          role: ROLE.INSTRUCTOR,
                          label: "INSTRUCTOR",
                        })
                      }
                    >
                      Instructor Login
                    </Typography>
                  </Stack>
                )}
                {/* Comment this while deploying on stagging or prod*/}
                {/* <Stack className="login_type_container marginTopMinus">
                  <Box>
                    <Typography className="loginType">
                      <div className="btn_container">
                        <Button
                          role="primary"
                          value={`Login as ${role.label ? role.label : ""}`}
                          className="login_btn"
                          onClick={loginfun}
                          disabled={
                            role.role
                              ? false
                              : location.pathname === APP_ROUTES.ADMIN_PATH
                              ? false
                              : true
                          }
                        />
                      </div>
                    </Typography>
                  </Box>
                </Stack> */}
              </>
            )}
          </Stack>
        </Stack>
      )}
    </>
  );
};

export default Login;
